import { ReactNode } from 'react';

import { IconProps } from '../icon';

export type FormInputSize = 'small' | 'regular' | 'large';
export type OptionValue = string | number;

export interface Option<T extends OptionValue = string> {
  value: T;
  label: string;
  title?: string;
  disabled?: boolean;
  description?: string;
  icon?: IconProps['name'];
  badge?: string;
  tooltip?: ReactNode;
}

export interface OptionGroup<T extends OptionValue = string> {
  label: string;
  options: Option<T>[];
}

export type SelectOption<T extends OptionValue = string> = Option<T> | OptionGroup<T>;

export type SelectOptions<T extends OptionValue = string> = SelectOption<T>[];

export const isOptionGroup = <T extends OptionValue = string>(
  item: SelectOption<T>,
): item is OptionGroup<T> => 'options' in item;
